import React, { useEffect, useState } from "react";
import {
  Paper,
  Button,
  Box,
  Typography,
  Avatar,
  Skeleton,
} from "@mui/material";
import freeVoteIconV from "../../../assets/customerAssets/icons/crownVoteIconRed.svg";
import freeVoteIcon from "../../../assets/customerAssets/icons/crownVoteIcon.svg";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addVote } from "../../../api/addVote";
import { addVote as addClubVote } from "../../../api/addClubVote";
import { addLeagueVote } from "../../../api/addLeagueVote";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import styles from "./voteComponent.module.css";

const VoteComponent = ({ vote, id, count, setCount, type }) => {
  const [loading, setLoading] = useState(false);
  const [clicked, setClicked] = useState(vote);
  // const [gcount, setCount] = useState(count);
  const navigate = useNavigate();

  /// get user data and token
  const user = useSelector((state) => state.user);
  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();
  const handleClicked = async () => {
    try {
      if (user.data.is_skip) {
        navigate("/register");
        return;
      }
      setLoading(true);
      if (token && user.data.id) {
        let data;
        if (type == "club") {
          data = await addClubVote(user.data.id, id, token, false);
        } else if (type == "league") {
          data = await addLeagueVote(user.data.id, id, token, false);
        } else {
          data = await addVote(user.data.id, id, token, false);
        }
        if (data.success) {
          setCount((v) => v + 1);
          setLoading(false);
          setClicked(true);
          /// decrement vote in redux
          dispatch({ type: "DCREMENT_VOTE" });
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      } else {
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: { xs: "35px", sm: "35px" },
          height: { xs: "35px", md: "35px" },
        }}
      >
        {loading ? (
          <Button
            className="icon-div"
            sx={{ minWidth: "unset" }}
            onClick={() => {}}
          >
            <Skeleton animation="wave" height={27} width={27} />
          </Button>
        ) : (
          <Button
            className={styles["voteC-icon-button"]}
            sx={{ minWidth: "unset" }}
            onClick={handleClicked}
          >
            <img
              src={vote || clicked ? freeVoteIconV : freeVoteIcon}
              className="iconImg"
            />
            <Typography component={"span"}>{" " + count}</Typography>
          </Button>
        )}
      </Box>
    </>
  );
};

export default VoteComponent;
